/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
import React, {
  ComponentType,
  useState
} from 'react'
import { connect } from 'react-redux'
import { hasPath } from 'ramda'
import {
  Table,
  Popup
} from 'semantic-ui-react'
import { format } from 'date-fns'
// Local
import If from './if'
import {
  allowPatientTabSchedulingProvider,
  allowPatientTabSchedulingCdi
} from './currentUserUtils'
import {
  FORMAT,
  PAGES,
  shouldRenderReskin2025,
  REVIEW,
  ENCOUNTER
} from '../../constant'
import ScheduleButton from './scheduleAppointment/scheduleButton'
import ScheduleModal from './scheduleAppointment/scheduleModal'
import MoreTableFooter from './moreTableFooter'
import MaxTableFooter from './maxTableFooter'
import { isCdiOrRestricted } from './roleUtils'
import { isOptum } from './tenantUtils'
import { toKebabCase } from '../v3/utils/utils'
import { RootState } from '../../store'

const SafeTable = Table as unknown as ComponentType<any>

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  computerColumns: any
  data: any
  onClick: any
  more: any
  max: any
  onMore: any
  sortOnHeaderClick: any
}

function ComputerTable(
  props: Props
  // props: TableProps & { reduxState: any }
) {
  const {
    computerColumns,
    currentUser,
    data,
    onClick,
    more,
    max,
    onMore,
    sortOnHeaderClick
  } = props

  const [
    isScheduleCallBeingMade,
    setIsScheduleCallBeingMade
  ] = useState<boolean>(false)

  const [
    isModalShowing,
    setIsModalShowing
  ] = useState<boolean>(false)

  const [
    encounterIdState,
    setEncounterIdState
  ] = useState<string>('')

  const scheduleButtonLabel = allowPatientTabSchedulingProvider(currentUser)
    ? 'Start Encounter'
    : (
      allowPatientTabSchedulingCdi(currentUser) &&
        isOptum(currentUser.tenantId)
        ? 'Start'
        : 'Schedule'
    )
  // const practitionerId = user.userId

  function ComputerCell(
    column: any,
    record: any
    // record: PatientRecordForDisplay
  ) {
    const { value } = column
    const { meta } = record
    const className = hasPath([ 'className' ], meta)
      ? meta.className
      : ''
    return (
      <Table.Cell
        key={ value }
        className={ toKebabCase(value) }
      >
        { record[`${value}_icon`] }
        <span className={ `${value} ${className}` }>
          { record[value] }
        </span>
      </Table.Cell>
    )
  }

  // function ComputerRow(record: PatientRecordForDisplay) {
  function ComputerRow(record: any) {
    const {
      id,
      meta,
      name,
      nextEncounter,
      prevEncounter,
      proposedEncounter
    } = record

    const shouldShowScheduleButton = (
      allowPatientTabSchedulingProvider(currentUser) ||
      (allowPatientTabSchedulingCdi(currentUser) && isCdiOrRestricted(currentUser.roles))
    )
    
    function startDateForNextEncounter() {
      if (nextEncounter && nextEncounter.encounterStart) {
        const dateTime = new Date(nextEncounter.encounterStart)
        return (
          <a href={ `${PAGES.ENCOUNTER_DETAIL}${nextEncounter.encounterId}` }>
            { format(dateTime, FORMAT.DATE) }
          </a>
        )
      }

      // if a previous encounter was scheduled (moved to PLANNED), but not yet marked RFP,
      // we can presume its actively being worked by a CDI and should be displayed over any future FINISHED encounters
      if ((prevEncounter && prevEncounter.encounterStatus === ENCOUNTER.STATUS.PLANNED && prevEncounter.reviewCode === REVIEW.CODE.OPEN) ||
      // If a PROPOSED encounter exists, and a previous encounter is completed and RFP, we want to continue displaying the FINISHED encounter
      // until the PROPOSED is scheduled 
      (proposedEncounter && prevEncounter && prevEncounter.encounterStatus === ENCOUNTER.STATUS.FINISHED && 
        prevEncounter.reviewCode === REVIEW.CODE.READY_FOR_PHYSICIAN
      ) ) {
        const dateTime = new Date(prevEncounter.encounterStart)
        return (
          <a href={ `${PAGES.ENCOUNTER_DETAIL}${prevEncounter.encounterId}` }>
            { format(dateTime, FORMAT.DATE) }
          </a>
        )
      }

      return <>No upcoming appointment scheduled.</>
    }

    function scheduleNewEncounterButton() {

      if (proposedEncounter && proposedEncounter.encounterStart && proposedEncounter.encounterId) {
        return (
          <>
            <ScheduleButton
              label={ scheduleButtonLabel }
              setIsModalShowing={ setIsModalShowing }
              setEncounterIdState={ setEncounterIdState }
              isScheduleCallBeingMade={ isScheduleCallBeingMade }
              encounterId={ proposedEncounter.encounterId }
              setIsScheduleCallBeingMade={ setIsScheduleCallBeingMade }
              isOptum={ isOptum(currentUser.tenantId) }
            />
            <a
              className="m-12px-left"
              href={ `${PAGES.PATIENT_SNAPSHOT}${proposedEncounter.encounterId}` }
              target="_blank"
              rel="noopener noreferrer"
            >
              View Patient
            </a>
          </>
        )
      }

      if (isOptum(currentUser.tenantId)) {
        return <></>
      }
      return <>Please contact your Curation Health client success manager.</>

    }

    const revisedRecord = {
      ...record,
      nextEncounter: shouldShowScheduleButton ? (
        startDateForNextEncounter()
      ) : (
        <></>
      ),
      newAppointment: shouldShowScheduleButton ? (
        scheduleNewEncounterButton()
      ) : (
        <></>
      ),
      name
    }

    const className = hasPath([ 'className' ], meta) ? meta.className : ''
    return (
      <Table.Row
        key={ id }
        onClick={ (event: any) => onClick(id, event) }
        className={ className }
      >
        { computerColumns.map(
          (computerColumn: any) =>
            ComputerCell(computerColumn, revisedRecord)
        ) }
      </Table.Row>
    )
  }

  function ComputerHeader(column: any) {
    const { name, value } = column
    return (
      <Table.HeaderCell
        onClick={ !sortOnHeaderClick ? null : sortOnHeaderClick(value) }
        key={ value }
        className={ toKebabCase(name) }
      >
        <Popup
          content={ column.tooltip ? column.tooltip : name }
          mouseEnterDelay={ column.tooltipDelay ? column.tooltipDelay : 500 }
          trigger={ <span>{ name }</span> }
        />
      </Table.HeaderCell>
    )
  }

  const color = shouldRenderReskin2025 ? 'black' : 'green'
  const tableClassName = shouldRenderReskin2025 ? 'reskin' : ''

  return (
    <>
      <ScheduleModal
        encounterIdState={ encounterIdState }
        setEncounterIdState={ setEncounterIdState }
        isModalShowing={ isModalShowing }
        setIsModalShowing={ setIsModalShowing }
        // practitionerId={ practitionerId }
        setIsScheduleCallBeingMade={ setIsScheduleCallBeingMade }
        user={ currentUser }
      />
      <SafeTable
        compact
        color={ color }
        selectable
        className={ tableClassName }
      >
        <Table.Header>
          <Table.Row>
            { computerColumns.map(ComputerHeader) }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          { data.map(ComputerRow) }
        </Table.Body>
        <If isTrue={ more }>
          <MoreTableFooter
            columns={ computerColumns.length }
            onMore={ onMore }
          />
        </If>
        <If isTrue={ max !== undefined }>
          <MaxTableFooter columns={ computerColumns.length } />
        </If>
      </SafeTable>
    </>
  )
}

export default connect(mapStateToProps)(ComputerTable)
